import { formatDateTime } from '../../helpers/formatters'
import { CustomerAreaSurfaceCard } from '../customer-area'
import { PrivacyRequestStatus } from './PrivacyRequestStatus'

type PrivacyRecentActivityCardProps = {
  title: string
  subtitle: string
  createdAtLabel: (date: string) => string
  emptyLabel: string
  locale: string
  neverLabel: string
  latestRequest: {
    id: string
    status: 'pending' | 'processing' | 'completed' | 'rejected' | 'expired'
    createdAt: string
  } | null
}

export const PrivacyRecentActivityCard = ({
  title,
  subtitle,
  createdAtLabel,
  emptyLabel,
  locale,
  neverLabel,
  latestRequest,
}: PrivacyRecentActivityCardProps) => (
  <CustomerAreaSurfaceCard title={title} subtitle={subtitle}>
    {latestRequest ? (
      <div className="ca-theme-transition rounded-2xl border border-(--color-border-default) bg-(--color-bg-card) px-4 py-3 text-sm">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <span className="font-semibold text-(--color-text-primary)">#{latestRequest.id}</span>
          <PrivacyRequestStatus status={latestRequest.status} />
        </div>
        <p className="mt-2 text-(--color-text-secondary)">
          {createdAtLabel(formatDateTime(latestRequest.createdAt, locale, neverLabel))}
        </p>
      </div>
    ) : (
      <p className="ca-theme-transition rounded-2xl border border-(--color-border-default) bg-(--color-bg-card) px-4 py-3 text-sm text-(--color-text-secondary)">
        {emptyLabel}
      </p>
    )}
  </CustomerAreaSurfaceCard>
)
